//■■■■■■■■■■■■■■■■■■■■
//■googleログイン
//■■■■■■■■■■■■■■■■■■■■
import React, { useState } from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, provider } from '../../config/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";


import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  arrayUnion,
  arrayRemove,
  increment,
  collection,
  query
} from "firebase/firestore";
import './Login.css'

const db = getFirestore();
const APP_VERSION = "1.0.0";

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/mobile/i.test(ua)) return "mobile";
  if (/tablet|ipad/i.test(ua)) return "tablet";
  return "desktop";
};

const saveUserToFirestore = async (user) => {
  const userRef = doc(db, "users", user.uid);
  const userSnap = await getDoc(userRef);
  const now = new Date(); // ISO string はあとで生成

  const activityEntry = {
    action: "login",
    at: now.toISOString(),
  };

  if (!userSnap.exists()) {
    await setDoc(userRef, {
      displayName: user.displayName || "",
      email: user.email,
      role: "user",
      assignedProjects: [],
      createdAt: now,
      lastLogin: now,
      loginCount: 1,
      totalSessions: 1,
      lastActiveAt: now,
      appVersion: APP_VERSION,
      deviceType: getDeviceType(),
      activityLog: [activityEntry],
      lastProjectAccessed: "",
    });
  } else {
    await updateDoc(userRef, {
      lastLogin: now,
      lastActiveAt: now,
      loginCount: increment(1),
      totalSessions: increment(1),
      appVersion: APP_VERSION,
      deviceType: getDeviceType(),
      activityLog: arrayUnion(activityEntry),
    });
  }
};

// 🔽 新ユーザーが pendingInvites にあるプロジェクトに自動追加
const autoAssignProjectsFromPending = async (user) => {
  const email = user.email;
  const uid = user.uid;

  const projectsSnapshot = await getDocs(collection(db, "projects"));

  for (const docSnap of projectsSnapshot.docs) {
    const data = docSnap.data();
    const projectID = docSnap.id;

    if ((data.pendingInvites || []).includes(email)) {
      const projectRef = doc(db, "projects", projectID);

      await updateDoc(projectRef, {
        pendingInvites: arrayRemove(email),
        members: arrayUnion(uid),
      });

      // ユーザー側にも projectID を追加
      const userRef = doc(db, "users", uid);
      await updateDoc(userRef, {
        assignedProjects: arrayUnion(projectID),
      });

      console.log(`✅ ${email} を ${projectID} に追加しました`);
    }
  }
};

const Login = ({ setIsAuth }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // URL から ?code=XXX を取得
  const searchParams = new URLSearchParams(location.search);
  const inviteCode = searchParams.get("code");

  const loginInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      console.log("Login successful:", user);

      console.log("Auth currentUser:", auth.currentUser);
      console.log("User from Google:", user);


      await saveUserToFirestore(user);
      await autoAssignProjectsFromPending(user); // ←★ここでプロジェクトに追加
      // 🔽 ここで招待コードがある場合の処理を追加
      if (inviteCode) {
        await autoJoinProjectByCode(user, inviteCode);
      }

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();

      const assignedProjects = userData.assignedProjects || [];
      if (assignedProjects.length > 0) {
        const lastAccessed = userData.lastProjectAccessed;
        const selectedProjectID = (lastAccessed && assignedProjects.includes(lastAccessed))
          ? lastAccessed
          : assignedProjects[0];

        localStorage.setItem("currentProjectID", selectedProjectID);
        
        // 🔽 プロジェクト名も取得して保存
        const projectRef = doc(db, "projects", selectedProjectID);
        const projectSnap = await getDoc(projectRef);
        if (projectSnap.exists()) {
          const projectName = projectSnap.data().name || "無名プロジェクト";
          localStorage.setItem("currentProjectName", projectName);
        } else {
          localStorage.setItem("currentProjectName", "不明なプロジェクト");
        }
        // console.log("currentProjectID を設定:", selectedProjectID);
      }

      localStorage.setItem("isAuth", "true");
      setIsAuth(true);
      navigate("/");

    } catch (error) {
      console.error("Login failed:", error);
      alert("ログインに失敗しました。もう一度お試しください。");
    }
  };

  // 招待コードからプロジェクトに参加させる
const autoJoinProjectByCode = async (user, code) => {
  const q = query(collection(db, "projects"));
  const snapshot = await getDocs(q);

  let matchedProject = null;
  snapshot.forEach(docSnap => {
    const data = docSnap.data();
    if (data.inviteCode === code) { // ← Firestoreに "inviteCode" フィールドを持たせる
      matchedProject = { id: docSnap.id, ...data };
    }
  });

  if (!matchedProject) {
    console.warn("❌ 該当する招待コードが見つかりません:", code);
    return;
  }

  const projectRef = doc(db, "projects", matchedProject.id);
  const userRef = doc(db, "users", user.uid);

  // プロジェクト側にユーザーを追加
  await updateDoc(projectRef, {
    members: arrayUnion(user.uid),
  });

  // ユーザー側にプロジェクトIDを追加
  await updateDoc(userRef, {
    assignedProjects: arrayUnion(matchedProject.id),
  });

  console.log(`✅ ${user.email} をプロジェクト ${matchedProject.name} に追加しました`);
};


  return (
    <div className="login-container">
      <div className="login-box">
        <p className="login-title">ログインして始める</p>
        <button className="google-login-btn" onClick={loginInWithGoogle}>
          Googleでログイン
        </button>
      </div>
    </div>
  );

};

export default Login;
